import styled from 'styled-components';

const AddMarketingStyled = styled.div`
  .setting-title {
    font-size: 23px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    color: #000000;
    margin: ${(props) => props.theme.spacing(7 / 2)} 0
      ${(props) => props.theme.spacing(7 / 4)}
      ${(props) => props.theme.spacing(7 / 4)};
  }
  .submit-wrap {
    /* padding: ${(props) => props.theme.spacing(9)} 0 0
      ${(props) => props.theme.spacing(15 / 2)}; */
    padding: ${(props) => props.theme.spacing(4)};
  }
  .button-group {
    padding-top: ${(props) => props.theme.spacing(3)};
    button {
      margin: 0 6px;
    }
    .coupons-setting-button {
      /* background: #ffffff; */
      border: 1px solid #666464;
      border-radius: 4px;
      font-size: 16px;
      font-family: FZLTZHK;
      font-weight: normal;
      /* color: #666464; */
      color: #ffffff;
      background-color: #666464;
    }
  }
`;

export default AddMarketingStyled;
